const propertyName = 'url_path_for_forms';
const currentPath = window.location.pathname;

if (currentPath === '/research' || currentPath.startsWith('/research/')) {
	const url = new URL(window.location.href);

	if (url.searchParams.get(propertyName) !== currentPath) {
		url.searchParams.set(propertyName, currentPath);

		window.history.replaceState(
			window.history.state,
			'',
			url.pathname + url.search + url.hash
		);
	}
}
